<template>
	<div :class="[ 'applause-meter-wrapper', rating ]">
		<div class="meter-fill"></div>
		<div class="meter-label">Applause</div>
	</div>
</template>

<script>

export default {
	name: 'ApplauseMeter',
	props: {
		rating: {
			type: String,
			required: true,
		},
	},
	mounted() {
		const id = `applause_${this.rating}`;
		this.$store.dispatch("sound/fx/play", { id, volume: 0, loop: true });
		this.$store.dispatch("sound/fade", { id, volume: 1, duration: 1500 });
	},
	beforeDestroy() {
		const id = `applause_${this.rating}`;
		this.$store.dispatch("sound/fade", { id, volume: 0, duration: 1500 });
	},
};
</script>

<style lang="scss" scoped>
	.applause-meter-wrapper {
		position: relative;
		height: 100%;
		border: 4px solid $off-white-dark;
		margin: 50px 30px;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;

		@include mobile {
			margin: 15px 20px;
			border: 3px solid $off-white-dark;
		}
	}

	.meter-fill {
		background: $alt-color;
		width: 100%;
		height: 0%;

		.poor & { animation: poor-applause 3s 3s infinite; }
		.fair & { animation: fair-applause 3s 3s infinite; }
		.medium & { animation: medium-applause 3s 3s infinite; }
		.good & { animation: good-applause 3s 3s infinite; }
		.very-good & { animation: very-good-applause 3s 3s infinite; }
	}

	.meter-label {
		position: absolute;
		color: $off-white-dark;
		font-family: $body-font-bold;
		font-size: $font-size-x-lg;
		text-transform: uppercase;
		bottom: 15px;
		left: 0;
		right: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		writing-mode: vertical-rl;

		@include mobile { font-size: $font-size-base; }

		@supports (text-orientation: upright) or (-webkit-text-orientation: upright) {
			-webkit-text-orientation: upright;
			text-orientation: upright;
			letter-spacing: -.15em;
		}

		@supports not ((text-orientation: upright) or (-webkit-text-orientation: upright)) {
			letter-spacing: .75em;
			transform: rotate(180deg);
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/game/sidebar/ApplauseMeter.vue